/// <summary>
/// Adjust归因逻辑
/// </summary>

import AdjustMgr from "@/Fwk/AdjustMgr";
import {KitTrack} from "../Track/KitTrack";
import {AdjustAttr} from "./AdjustAttr";
import {AdjustBase} from "./AdjustBase";
// import {Action} from "@/Fwk/Kit/KitConst";
import SdkTrack from "../SdkTrack";
import {JsonData} from "@/Fwk/Kit/JsonData";

/// <author>xiexingwu</author>
export class AdjustWeb extends AdjustBase {
    Init(onChangedAction: () => void) {
        if (onChangedAction != null) this.AddListener(onChangedAction);
        KitTrack._task.AddTask(0.5, ()=>{this.Loop()}, "webAdjust", -1);
    }

    private Loop() {
        const time = new Date().getTime();
        let attrJson: string = AdjustMgr.getAdjustAttrObj;
        if (attrJson && time - this.startTime <= 30000) {
            return;
        }
        KitTrack._task.RemoveTask("webAdjust");
        this.OnAttr(new AdjustAttr(attrJson));
    }

    override GetAdjustAttribution() {
        let attrJson = AdjustMgr.getAdjustAttrObj;

        if (!attrJson) {
            return;
        }
        this.OnAttr(new AdjustAttr(attrJson));
    }

    AdjustEvent(token: string, dic: Map<string, string>) {
        const evn = new JsonData();
        // evn.put("token", token);
        if (dic != null) {
            dic.forEach((item,key)=>{
                evn.put(key, item ?? "");
            })
        }

        AdjustMgr.trackEvent({
            eventToken: "{YourEventToken}",
            ...dic
        })
    }

    trackAdjustEvent(token: string, revenue: number) {
        const evn = new JsonData();
        evn.put("revenue", revenue);
        evn.put("currency", "USD");
        AdjustMgr.trackEvent({
            eventToken: "{YourEventToken}",
            ...evn
        });
    }
}
